import React, { useState } from 'react';
import { GetServerSideProps } from 'next';

import { SimpleHeader } from '@/components';
import { ForgotPasswordForm } from '@/components/forms/forms';
import { useIsMobile } from '@/hooks';
import { getServerSidePropsWithGlobalData } from '@/lib/getServerSideProps';
import { withUrql } from '@/lib/urqlClient';

import styles from './styles.module.scss';

const ForgotPassword = ({}) => {
  const [isMobile] = useIsMobile(768);
  const [sent, setSent] = useState(false);

  return (
    <div className={styles.forgotPassword} data-testid="forgot-password">
      <div className={styles.inner} data-sent={sent}>
        {isMobile && !sent && <SimpleHeader href="/">Reset your password</SimpleHeader>}
        <h1>{sent ? 'Thank you!' : !isMobile && 'Reset your password'}</h1>
        <p>
          {sent
            ? 'Check your inbox for our password reset email.'
            : 'Enter your email to receive a link to reset your password'}
        </p>
        <ForgotPasswordForm sent={sent} setSent={setSent} />
      </div>
    </div>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) =>
  await getServerSidePropsWithGlobalData(ctx, async () => ({ props: {} }));

export default withUrql(ForgotPassword);
